/*
 * --------------------------------------
 * Copyright (c) 2019 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

import { Formik, Field } from 'formik';
import * as Yup from "yup";
import Alert from '../../shared/components/Alert';

import FormField from '../../shared/components/form/FormField';
import logo from '../../images/logo.png';
import { forgotpassword } from '../../actions/auth/authAction';


const validationSchema = Yup.object({
  email: Yup.string("").email('Enter valid email')
    .required("Email is required")
    .max(100, 'Email too long'),

});

class ForgotPassword extends PureComponent {
  state = {
    loading: false,
  };

  handleSubmit = (values) => {
    this.setState({ loading: true, error: null, })
    this.props.forgotpassword({
      email: values.email
    });
  }

  componentDidMount() {
    if (this.props.auth.isAuthenticated)
      this.props.history.push('/');
  }

  componentWillReceiveProps(nextProps) {
    const { passProp } = nextProps;
    if (this.state.loading) {
      if (passProp.forgotPassSucc === true) {
        this.setState({ loading: false, success: "Password reset email has been sent" });
      } else if (passProp.forgotPassSucc === false)
        this.setState({ loading: false, error:passProp.message });
    }
  }

  render() {
    let alertContent;
    const initialValues = {email:''};
    const { error, success, loading } = this.state;
    if (error) {
      alertContent = (
        <Alert color="danger" className="alert--bordered" icon>
          <p>{error}</p>
        </Alert>
      );
    } else if (success) {
      alertContent = (
        <Alert color="success" className="alert--bordered" icon>
          <p>{success}</p>
        </Alert>);
    }

    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <img src={logo} alt="BetterCapital.US" />
            </div>
            <h3 style={{ textAlign: 'center' }}>Forgot Password</h3>
            {alertContent}
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={this.handleSubmit}
              render={props => {
                const { handleSubmit } = props;

                return (
                  <Fragment>
                    <form className="form" onSubmit={handleSubmit}>
                      <div className="form__form-group form__form-group--forgot">
                        <span className="form__form-group-label">Email</span>
                        <div className="form__form-group-field">
                          <Field
                            name="email"
                            component={FormField}
                            placeholder="Email"
                          />

                        </div>
                      </div>

                      <div className="account__btns">
                        <button className="btn btn-primary account__btn"
                          disabled={loading} type="submit">{loading ? 'Please wait...' : 'Send Reset Email'}</button>
                      </div>
                    </form>

                    <div className="account__have-account">
                      <p>Go <Link to="/">Home</Link></p>
                    </div>
                  </Fragment>
                )
              }
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.login,
  passProp: state.pass
});
const mapDispatchToProps = dispatch => ({
  forgotpassword: (userData) => forgotpassword(userData, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgotPassword))
